export const isProductsMenuItem = (itemTitle: string): boolean => {
  return itemTitle === 'Produtos'
}

export const hasProductsData = (subItem: any): boolean => {
  return subItem && Array.isArray(subItem.products)
}
